let close_btn = document.querySelector(".discount-popup-image button");

function shouldShowPopup() {
  const lastShown = localStorage.getItem("lastDiscountShownTimetamp");
  if (!lastShown) return true;

  const now = new Date().getTime();
  const timeSinceLastShow = now - parseInt(lastShown);
  return timeSinceLastShow > 5 * 60 * 1000; // 5 minutes
}

if(shouldShowPopup()){
    document.querySelector(".discount-popup-container").style.display = "flex";

}
close_btn.addEventListener("click", () => {
  document.querySelector(".discount-popup-container").style.display = "none";
});

close_btn.addEventListener("click", () => {
  document.querySelector(".discount-popup-container").style.display = "none";
  localStorage.setItem("lastDiscountShownTimetamp", Date.now().toString());
});

document
  .querySelector(".discount-popup-container")
  .addEventListener("click", () => {
    document.querySelector(".discount-popup-container").style.display = "none";
    localStorage.setItem("lastDiscountShownTimetamp", Date.now().toString());
  });
